import ColorSwatchIcon from '../../../../bom/components/ColorSwatchIcon';
import LocalImageIcon from '../../../../bom/components/LocalImageIcon';
import PropTypes from 'prop-types';
import React from 'react';
import Scene7ImageIcon from '../../../../bom/components/Scene7ImageIcon';
import { ThumbnailType } from '../../../../bom/constants';
import styles from './OptionName.scss';

const OptionName = ({ option, questionId, thumbnailType }) => {
  const { codeValue, colorReference, description } = option;

  return (
    <div className={styles['option-name']}>
      {thumbnailType === ThumbnailType.COLOR_SWATCH ? (
        <ColorSwatchIcon color={colorReference} size="sm" />
      ) : thumbnailType === ThumbnailType.LOCAL_IMAGE ? (
        <LocalImageIcon imageName={codeValue} size="sm" />
      ) : thumbnailType === ThumbnailType.SCENE7_IMAGE ? (
        <Scene7ImageIcon option={option} questionId={questionId} />
      ) : null}
      <span>{description}</span>
    </div>
  );
};

OptionName.propTypes = {
  option: PropTypes.shape({
    code: PropTypes.string.isRequired,
    codeValue: PropTypes.string.isRequired,
    colorGroupList: PropTypes.arrayOf(PropTypes.string).isRequired,
    colorReference: PropTypes.string.isRequired,
    componentId: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    estimatedShipDate: PropTypes.string.isRequired,
    futureShipDateSettingStatus: PropTypes.oneOf([0, 1, 2]).isRequired,
    helpLink: PropTypes.shape({
      helpText: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    }),
    inventoryMessage: PropTypes.string.isRequired,
    isFutureShipDateSettable: PropTypes.bool.isRequired,
    isOutOfStock: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isSoldOut: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    optionText: PropTypes.string.isRequired,
    outOfStockMessage: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    sequence: PropTypes.number.isRequired,
    specialBomCharge: PropTypes.string.isRequired,
    useTexture: PropTypes.bool.isRequired,
    yearOptionPricing: PropTypes.oneOf([0, 1, 2]).isRequired,
  }).isRequired,
  questionId: PropTypes.number.isRequired,
  thumbnailType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
};

export default OptionName;
